import styled from "styled-components";

export const MainContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%; 
   
`;
export const HistoryContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;  
    height: calc(100vh - 324px);
    min-height: 0;    
    overflow-y: auto;    
    border-radius: 8px;
`;

export const ItemContainerEmailHistory = styled.div`
    display: flex;
    flex-direction: row;
    gap: 16px;
    align-items: flex-start;
    width: 100%;

    & > .col-2 {
    flex: 1 1 auto;
    width: 100%;
  }

`;


export const ItemEmailHistory = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
`;  

export const ItemEmailHistoryHeader = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`;

export const HeaderActionContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    gap: 4px;
    flex: 1;
`;

export const DateContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    min-width: 120px;
`;
export const ItemEmailHistoryMeta = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const FromToContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 28px;
`;

export const MetaItem = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const CcItemsContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 4px;
`;

export const ItemEmailHistoryBody = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
`;

export const SummaryCardContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const SummaryCardHeader = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`;
export const SummaryHeaderLeftContainer = styled.div`
    display: flex;
    gap: 4px;
`;

export const AvatarContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const IconContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`;

